<c3-config-section-box
  [title]="TP_SECTIONS_INFO['telemonitoring'].label"
  [icon]="TP_SECTIONS_INFO['telemonitoring'].icon"
  (onSaveComplete)="onSaveComplete()"
>
  <p config-description>{{ TP_SECTIONS_INFO["telemonitoring"].description }}</p>

  <div [c3ConfigForm]="this" [formGroup]="form" #tmForm>
    <div *ngIf="loading$ | async">
      <ion-grid>
        <ion-row class="ion-align-items-center">
          <ion-col size="12" class="c3-flex ion-justify-content-center ion-align-items-center">
            <ion-spinner color="secondary"></ion-spinner>
          </ion-col>
          <ion-col size="12" class="ion-text-center">
            <span>Caricamento in corso...</span>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div class="tm-section" *ngIf="!(loading$ | async)">
      <h3 class="mat-subheading-2 layout-row layout-align-start-center">
        <mat-icon svgIcon="chevron-right" color="primary"></mat-icon>
        <b>Telemonitoraggio</b>
      </h3>

      <div class="tm-section-content">
        <p>
          Attivando il telemonitoraggio sarà possibile accedere alla dashboard e visualizzare tutti
          i dati clinici del paziente
        </p>

        <div *ngIf="teleArray">
          <div formArrayName="teleArray">
            <div
              class="mb-3"
              *ngFor="let fg of teleArray.controls; let i = index"
              [formGroupName]="i"
            >
              <p class="d-flex flex-column gap-12">
                <span
                  >Telemonitoraggio
                  <strong>{{ contextInfo[fg.get("contextId")?.value]?.label }}</strong></span
                >

                <!-- 2) usa formControlName per telemonitoring -->
                <mat-button-toggle-group
                  class="c3-toggle-group"
                  color="accent"
                  formControlName="telemonitoring"
                  (change)="onToggleTele(i, $event.value)"
                >
                  <mat-button-toggle [value]="true">Sì</mat-button-toggle>
                  <mat-button-toggle [value]="false">No</mat-button-toggle>
                </mat-button-toggle-group>
              </p>

              <!-- Se attivo, mostra impostazioni data -->
              <ng-container *ngIf="fg.get('telemonitoring')?.value === true">
                <div class="layout-col layout-align-start-start gap-12 my-3">
                  <span>Telemonitoraggio attivo fino a</span>

                  <div class="layout-row align-items-start gap-8">
                    <!-- 3) tmDatesType reattivo -->
                    <!-- <mat-button-toggle-group
                      class="c3-toggle-group"
                      color="accent"
                      formControlName="tmDatesType"
                      (change)="onDatesTypeChange(i, $event.value)"
                    >
                      <mat-button-toggle [value]="'end_of_prescription'">
                        Termine Attivazione
                      </mat-button-toggle>
                      <mat-button-toggle [value]="'specific_date'">
                        Data specifica
                      </mat-button-toggle>
                    </mat-button-toggle-group> -->

                    <!-- 4) Datepicker visibile solo per 'specific_date' -->
                    <!-- <ng-container *ngIf="fg.get('tmDatesType')?.value === 'specific_date'"> -->
                    <mat-form-field>
                      <input
                        matInput
                        [matDatepicker]="endPicker"
                        placeholder="Seleziona una data"
                        [min]="fg.get('start_date')?.value || null"
                        [max]="appPrescrEndDate"
                        formControlName="end_date"
                        readonly
                      />
                      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                      <mat-datepicker #endPicker></mat-datepicker>

                      <!-- 5) errori legati al validator di riga -->
                      <mat-error *ngIf="fg.errors?.endRequired && fg.touched">
                        La data di fine è obbligatoria.
                      </mat-error>
                      <mat-error *ngIf="fg.errors?.endBeforeStart && fg.touched">
                        La data di fine deve essere ≥ della data di inizio.
                      </mat-error>
                    </mat-form-field>
                    <!-- </ng-container> -->
                  </div>
                </div>
              </ng-container>

              <!-- Messaggi errori generali di riga -->
              <div class="text-warn" *ngIf="fg.errors && fg.touched">
                <div *ngIf="fg.errors.startRequired">La data di inizio è obbligatoria.</div>
                <div *ngIf="fg.errors.endRequired">La data di fine è obbligatoria.</div>
                <div *ngIf="fg.errors.endBeforeStart">
                  La data di fine deve essere ≥ della data di inizio.
                </div>
              </div>

              <div class="my-3">
                <mat-divider></mat-divider>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="consensusDeniedFromApp">
          <p class="layout-row layout-align-start-center gap-12">
            <span style="color: red">{{ consensusText }}</span>
          </p>
        </div>

        <ng-container *ngIf="!isTelemonitoringEnabled && parentContext === CTXS_PARENT.GRAVIDANZA">
          <p class="layout-row layout-align-start-center gap-12">
            <span>Motivo (*)</span>

            <mat-form-field class="field">
              <mat-select formControlName="telemonEndReason">
                <mat-option *ngFor="let reason of this.reasonList" [value]="reason"
                  >{{ reason }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </p>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="isTelemonitoringEnabled">
      <div class="tm-section" *ngIf="!(loading$ | async)">
        <h3 class="mat-subheading-2 layout-row layout-align-start-center">
          <mat-icon svgIcon="chevron-right" color="primary"></mat-icon>
          <b>Chat</b>
        </h3>

        <div class="tm-section-content">
          <p class="layout-row layout-align-start-center gap-12">
            <span>Chat con il paziente abilitata</span>

            <mat-button-toggle-group
              class="c3-toggle-group"
              name="chatEnabled"
              formControlName="isChatEnabled"
              color="accent"
            >
              <mat-button-toggle [value]="true">Sì</mat-button-toggle>
              <mat-button-toggle [value]="false">No</mat-button-toggle>
            </mat-button-toggle-group>
          </p>
        </div>
      </div>

      <ng-container *ngIf="shouldShowWarningSelections">
        <div class="tm-section" *ngIf="!(loading$ | async)">
          <h3 class="mat-subheading-2 layout-row layout-align-start-center">
            <mat-icon svgIcon="chevron-right" color="primary"></mat-icon>
            <b>Alerts e segnalazioni a Operatori Sanitari</b>
          </h3>

          <div class="tm-section-content">
            <c3-warnings-selectable-list
              [availableWarnings]="availableWarnings$ | async"
              [filters]="['os', context$ | async]"
              formControlName="warningsSelection"
            >
            </c3-warnings-selectable-list>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</c3-config-section-box>
